import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-249b0656")
const _hoisted_1 = { class: "columns" }
const _hoisted_2 = {
  key: 0,
  class: "column"
}
const _hoisted_3 = { class: "field is-horizontal" }
const _hoisted_4 = {
  class: "select",
  style: {"display":"inline-block"}
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<option data-v-249b0656>Select</option><option value=\"1\" data-v-249b0656>Location Id</option><option value=\"2\" data-v-249b0656>Utility Type</option><option value=\"3\" data-v-249b0656>Report No</option><option value=\"4\" data-v-249b0656>Client Meter Ref</option><option value=\"5\" data-v-249b0656>Client Site Ref</option><option value=\"6\" data-v-249b0656>Supplier</option><option value=\"7\" data-v-249b0656>Address</option><option value=\"8\" data-v-249b0656>Meter Serial No</option><option value=\"9\" data-v-249b0656>Supplier Acc No</option><option value=\"10\" data-v-249b0656>Invoice No</option><option value=\"11\" data-v-249b0656>Tax Point</option><option value=\"12\" data-v-249b0656>Bill Period</option><option value=\"13\" data-v-249b0656>Net</option><option value=\"14\" data-v-249b0656>VAT</option><option value=\"15\" data-v-249b0656>Total</option>", 16)
const _hoisted_21 = [
  _hoisted_5
]
const _hoisted_22 = {
  key: 0,
  class: "m-l-sm padding6px",
  style: {"display":"inline-block"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "padding6px" }, " From ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "padding6px" }, " To ", -1)
const _hoisted_25 = {
  key: 1,
  class: "select padding6px",
  style: {"display":"inline-block"}
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Electricity", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Gas", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Water", -1)
const _hoisted_29 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 2,
  class: "m-l-sm padding6px",
  style: {"display":"inline-block"}
}
const _hoisted_31 = {
  class: "m-l-sm padding6px",
  style: {"display":"inline-block"}
}
const _hoisted_32 = {
  key: 3,
  class: "col-md-3 padding6px"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, " From ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, " To ", -1)
const _hoisted_35 = {
  key: 4,
  class: "m-l-sm",
  style: {"display":"inline-block"}
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "padding6px" }, " From ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "padding6px" }, " To ", -1)
const _hoisted_38 = {
  class: "m-l-sm padding6px",
  style: {"display":"inline-block"}
}
const _hoisted_39 = ["disabled"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"inline-block"} }, [
  /*#__PURE__*/_createElementVNode("label", null, " ")
], -1)
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 1,
  style: {"padding-top":"15px","width":"20% !important"}
}
const _hoisted_43 = {
  class: "dropdown",
  style: {"padding-left":"10px !important"}
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("button", { class: "dropdown-btn button is-primary is-small padding6px" }, " Show/Hide Columns ", -1)
const _hoisted_45 = { class: "dropdown-content" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Location Id ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Utility Type ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Report No ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Client Meter Ref ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Client Site Ref ")
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Supplier          ")
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Address ")
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Meter Serial No ")
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Supplier Acc No ")
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Invoice No          ")
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Tax Point          ")
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Bill Period          ")
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Net                   ")
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" VAT                   ")
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Total          ")
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "selected-options" }, null, -1)
const _hoisted_62 = {
  key: 0,
  class: "custom-row-icons"
}
const _hoisted_63 = ["onChange"]
const _hoisted_64 = ["src"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_VTable = _resolveComponent("VTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isfolderContent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchType = $event))
                    }, _hoisted_21, 512), [
                      [_vModelSelect, _ctx.searchType]
                    ])
                  ]),
                  (_ctx.searchType == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _withDirectives(_createElementVNode("input", {
                          class: "padding6px",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fromLOC = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.fromLOC]
                        ]),
                        _hoisted_24,
                        _withDirectives(_createElementVNode("input", {
                          class: "padding6px",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.toLOC = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.toLOC]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.searchType == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchUtilty = $event))
                        }, _hoisted_29, 512), [
                          [_vModelSelect, _ctx.searchUtilty]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.searchType == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.rptNo = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.rptNo]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_31, [
                    (
                  _ctx.searchType == 4 ||
                  _ctx.searchType == 5 ||
                  _ctx.searchType == 6 ||
                  _ctx.searchType == 7 ||
                  _ctx.searchType == 8 ||
                  _ctx.searchType == 9 ||
                  _ctx.searchType == 10
                )
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          ref: "searchText",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchText = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.searchText]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.searchType == 11 || _ctx.searchType == 12)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _hoisted_33,
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.fromDate,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.fromDate = $event)),
                          type: "date",
                          format: "DD/MM/YYYY"
                        }, null, 8, ["modelValue"]),
                        _hoisted_34,
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.toDate,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.toDate = $event)),
                          type: "date",
                          format: "DD/MM/YYYY"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.searchType == 13 || _ctx.searchType == 14 || _ctx.searchType == 15)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _hoisted_36,
                        _withDirectives(_createElementVNode("input", {
                          class: "padding6px",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.fromLOC = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.fromLOC]
                        ]),
                        _hoisted_37,
                        _withDirectives(_createElementVNode("input", {
                          class: "padding6px",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.toLOC = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.toLOC]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("button", {
                      class: "button is-primary is-small padding6px",
                      disabled: !_ctx.enableSearch || !_ctx.searchType,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.search()))
                    }, " Search ", 8, _hoisted_39),
                    _hoisted_40,
                    _createElementVNode("button", {
                      class: "button m-l-sm is-primary is-small padding6px",
                      disabled: !_ctx.enableSearch && !_ctx.searchType,
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearSearch()))
                    }, " Clear ", 8, _hoisted_41)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isfolderContent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("button", {
                class: "button is-primary is-small padding6px",
                style: {"margin-right":"10px !important"},
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.ReloadScreen()))
              }, " Back "),
              _createElementVNode("button", {
                class: "button is-primary is-small padding6px",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.downloadInvoices()))
              }, " Download "),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.showLOCId = $event)),
                      onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showHideCols(1)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showLOCId]
                    ]),
                    _hoisted_46
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.showUtility = $event)),
                      onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showHideCols(2)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showUtility]
                    ]),
                    _hoisted_47
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.showRptNo = $event)),
                      onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showHideCols(3)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showRptNo]
                    ]),
                    _hoisted_48
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.showCMR = $event)),
                      onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showHideCols(4)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showCMR]
                    ]),
                    _hoisted_49
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.showCSR = $event)),
                      onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showHideCols(5)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showCSR]
                    ]),
                    _hoisted_50
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.showSupplier = $event)),
                      onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showHideCols(6)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showSupplier]
                    ]),
                    _hoisted_51
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.showAddress = $event)),
                      onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showHideCols(7)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showAddress]
                    ]),
                    _hoisted_52
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.showMSN = $event)),
                      onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showHideCols(8)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showMSN]
                    ]),
                    _hoisted_53
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.showSAC = $event)),
                      onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showHideCols(9)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showSAC]
                    ]),
                    _hoisted_54
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.showInvoice = $event)),
                      onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.showHideCols(10)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showInvoice]
                    ]),
                    _hoisted_55
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.showTP = $event)),
                      onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.showHideCols(11)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showTP]
                    ]),
                    _hoisted_56
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.showBP = $event)),
                      onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.showHideCols(12)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showBP]
                    ]),
                    _hoisted_57
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.showNet = $event)),
                      onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.showHideCols(13)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showNet]
                    ]),
                    _hoisted_58
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.showVat = $event)),
                      onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.showHideCols(14)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showVat]
                    ]),
                    _hoisted_59
                  ]),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.showTotal = $event)),
                      onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.showHideCols(15)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.showTotal]
                    ]),
                    _hoisted_60
                  ])
                ])
              ]),
              _hoisted_61
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_VTable, {
        header: _ctx.header,
        content: _ctx.foldercontent
      }, {
        content: _withCtx(({ data }) => [
          (data.col.key === 'Action' || data.col.key == 'Action')
            ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  onChange: ($event: any) => (_ctx.addtoDownload(data))
                }, null, 40, _hoisted_63)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["header", "content"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("template", null, [
        _createElementVNode("iframe", {
          src: _ctx.pdfUrl,
          width: "100%",
          height: "500px"
        }, null, 8, _hoisted_64)
      ])
    ])
  ], 64))
}